import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=429e8eec"
import script from "./FieldCheckbox.vue?vue&type=script&lang=ts"
export * from "./FieldCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FieldWrapper: require('/builds/project/wyffest/frontend/components/field/FieldWrapper.vue').default})
